import Papa, { ParseConfig, ParseResult, LocalFile } from "papaparse";

const emailRegex =
  /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

export function testEmail(email: string): boolean {
  return emailRegex.test(email);
}

export function formatBytesHumanFriendly(bytes: number, decimals = 2): string {
  if (bytes === 0) return "0 Bytes";

  const k = 1024;
  const dm = decimals < 0 ? 0 : decimals;
  const sizes = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];

  const i = Math.floor(Math.log(bytes) / Math.log(k));

  return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + " " + sizes[i];
}

type OnCompleteFn<T> = (results: ParseResult<T>, file?: LocalFile) => void;
export function papaParseWithPromise<T>(
  file: File,
  papaConfig: ParseConfig<T>
): Promise<ParseResult<T>> {
  return new Promise<ParseResult<T>>(function (
    complete: OnCompleteFn<T>,
    error
  ) {
    Papa.parse<T>(file, { ...papaConfig, complete, error });
  });
}

export function missingProperties(
  obj: unknown,
  expectedProperties: string[]
): string[] {
  return expectedProperties.filter(
    (prop) => (obj as Record<string, unknown>)[prop] === undefined
  );
}

type AOAKeys = string | number;
export function convertFromAOAToAOO(
  data: Array<AOAKeys[]>
): Record<AOAKeys, unknown>[] {
  //convert from array of array to array of object | not used yet
  const collection = data.slice(); // make a copy
  const keys = collection.shift();
  if (keys === undefined) {
    // data is empty
    return [];
  }

  return collection.map((e) => {
    const obj: Record<AOAKeys, unknown> = {};
    keys?.forEach((key: AOAKeys, i: number) => {
      obj[key] = e[i];
    });

    return obj;
  });
}

export function formatDate(date: Date): string {
  return date.toLocaleDateString('es-ES', {
    weekday: 'long',
    year: 'numeric',
    month: 'long',
    day: 'numeric',
  });
}
